module.exports = __webpack_public_path__ + "img/dd6.69ac609d.png";